export const minBigInt = (
  values: Array<bigint | undefined>
): bigint | undefined => {
  return values.reduce<bigint | undefined>((oldestValue, value) => {
    if (value === undefined) {
      return oldestValue;
    }
    if (oldestValue === undefined) {
      return value;
    }
    return value < oldestValue ? value : oldestValue;
  }, undefined);
};
